import p from 'x/config/platform-specific'

const XWebView = p.comp.getXWebView()

export default XWebView
